// import React from 'react'
// import { Navbar, Nav, Container } from 'react-bootstrap'
// import Logo from '../Assets/Assests/final_logo_AI museum.png'
// import '../Styles/Header.css'
// import { Link } from 'react-router-dom'
// import AiLogo from '../Assets/Assests/FinalLogo.png'

// const Header = () => {

//   const scrollToSection = (id) => {
//     const section = document.getElementById(id)
//     if (section) {
//       const offset = 80 // Adjust based on your navbar height
//       const sectionPosition =
//         section.getBoundingClientRect().top + window.scrollY
//       window.scrollTo({
//         top: sectionPosition - offset,
//         behavior: 'smooth',
//       })
//     }
//   }

//   return (
//     <Navbar
//       expand='md'
//       fixed='top'
//       className='bg-white shadow-lg w-100'
//       style={{
//         backdropFilter: 'blur(10px)',
//         transition: 'all 0.3s ease-in-out',
//         maxWidth: '100vw',
//         overflowX: 'hidden',
//       }}
//     >
//       <Container fluid>
//         {/* Logo Section */}
//         <Navbar.Brand
//           className='d-flex align-items-center flex-wrap'
//           style={{ maxWidth: '100%' }}
//         >
//           <img
//             src={AiLogo}
//             alt='Museum Logo'
//             className='me-2'
//             width={210}
//             height={80}
//             style={{ marginRight: '20px', marginLeft: '20px' }}
//           />
//         </Navbar.Brand>

//         {/* Toggle Button for Mobile */}
//         <Navbar.Toggle aria-controls='basic-navbar-nav' />

//         {/* Navbar Links */}
//         <Navbar.Collapse id='basic-navbar-nav' className='justify-content-end'>
//           <Nav className='align-items-center'>
//             {[
//               { id: 'home', label: 'Home' },
//               { id: 'impact', label: 'Impact' },
//               { id: 'members', label: 'Members' },
//               { id: 'ai-museum', label: 'AI Museum' },
//               { href: '/sign-in', label: 'Login', isLink: true },
//             ].map(({ id, label, href, isLink }) =>
//               isLink ? (
//                 <Link
//                   key={label}
//                   to={href}
//                   className='nav-link'
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px',
//                     color: '#555',
//                     fontWeight: '500',
//                     padding: '10px 20px',
//                     margin: '0 10px',
//                     transition: 'color 0.3s ease, transform 0.3s ease',
//                     cursor: 'pointer',
//                     textDecoration: 'none',
//                   }}
//                   onMouseEnter={(e) => (e.target.style.color = '#B02013')}
//                   onMouseLeave={(e) => (e.target.style.color = '#555')}
//                 >
//                   {label}
//                 </Link>
//               ) : (
//                 <span
//                   key={id}
//                   className='nav-link'
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '10px',
//                     color: '#555',
//                     fontWeight: '500',
//                     padding: '10px 20px',
//                     margin: '0 10px',
//                     transition: 'color 0.3s ease, transform 0.3s ease',
//                     cursor: 'pointer',
//                   }}
//                   onClick={() => scrollToSection(id)}
//                   onMouseEnter={(e) => (e.target.style.color = '#B02013')}
//                   onMouseLeave={(e) => (e.target.style.color = '#555')}
//                 >
//                   {label}
//                 </span>
//               )
//             )}
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   )
// }

// export default Header

// import React from 'react'
// import { Navbar, Nav, Container } from 'react-bootstrap'
// import Logo from '../Assets/Assests/final_logo_AI museum.png'
// import '../Styles/Header.css'
// import { Link } from 'react-router-dom'
// import AiLogo from '../Assets/Assests/shared image- 1 (2).png'

// const Header = () => {
//   const scrollToSection = (id) => {
//     const section = document.getElementById(id)
//     if (section) {
//       const offset = 80 // Adjust based on your navbar height
//       const sectionPosition =
//         section.getBoundingClientRect().top + window.scrollY
//       window.scrollTo({
//         top: sectionPosition - offset,
//         behavior: 'smooth',
//       })
//     }
//   }

//   return (
//     <Navbar
//       expand='md'
//       fixed='top'
//       className='bg-white shadow-lg w-100'
//       style={{
//         backdropFilter: 'blur(10px)',
//         transition: 'all 0.3s ease-in-out',
//         maxWidth: '100vw',
//         overflowX: 'hidden',
//       }}
//     >
//       <Container fluid>
//         {/* Logo Section */}
//         <Navbar.Brand
//           className='d-flex align-items-center flex-wrap'
//           style={{ maxWidth: '100%' }}
//         >
//           <img
//             src={AiLogo}
//             alt='Museum Logo'
//             className='me-2'
//             width={180}
//             height={60}
//             style={{ marginRight: '20px', marginLeft: '20px' }}
//           />
//         </Navbar.Brand>

//         {/* Toggle Button for Mobile */}
//         <Navbar.Toggle aria-controls='basic-navbar-nav' />

//         {/* Navbar Links */}
//         <Navbar.Collapse id='basic-navbar-nav' className='justify-content-end'>
//           <Nav className='align-items-center'>
//             {[
//               { href: '/', label: 'Home', isLink: true },
//               {
//                 href: '/ai-global-museum',
//                 label: 'AI Global Museum',
//                 isLink: true,
//               },
//               {
//                 href: '/tesla-bird-membership',
//                 label: 'Tesla Bird Membership',
//                 isLink: true,
//               },
//               { href: '/give-back', label: 'Give Back', isLink: true },
//               { href: '/sign-in', label: 'Login', isLink: true },
//             ].map(({ id, label, href, isLink }) =>
//               isLink ? (
//                 <Link
//                   key={label}
//                   to={href}
//                   className='nav-link'
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px',
//                     color: '#555',
//                     fontWeight: '500',
//                     padding: '10px 20px',
//                     margin: '0 10px',
//                     transition: 'color 0.3s ease, transform 0.3s ease',
//                     cursor: 'pointer',
//                     textDecoration: 'none',
//                   }}
//                   onMouseEnter={(e) => (e.target.style.color = '#B02013')}
//                   onMouseLeave={(e) => (e.target.style.color = '#555')}
//                 >
//                   {label}
//                 </Link>
//               ) : (
//                 <span
//                   key={id}
//                   className='nav-link'
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '10px',
//                     color: '#555',
//                     fontWeight: '500',
//                     padding: '10px 20px',
//                     margin: '0 10px',
//                     transition: 'color 0.3s ease, transform 0.3s ease',
//                     cursor: 'pointer',
//                   }}
//                   onClick={() => scrollToSection(id)}
//                   onMouseEnter={(e) => (e.target.style.color = '#B02013')}
//                   onMouseLeave={(e) => (e.target.style.color = '#555')}
//                 >
//                   {label}
//                 </span>
//               )
//             )}
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   )
// }
// export default Header

// import React from 'react'
// import { Navbar, Nav, Container } from 'react-bootstrap'
// import Logo from '../Assets/Assests/final_logo_AI museum.png'
// import '../Styles/Header.css'
// import { Link } from 'react-router-dom'
// import { useLocation } from 'react-router-dom'
// import AiLogo from '../Assets/Assests/shared image- 1 (2).png'

// const Header = () => {
//   const location = useLocation()

//   const scrollToSection = (id) => {
//     const section = document.getElementById(id)
//     if (section) {
//       const offset = 80
//       const sectionPosition =
//         section.getBoundingClientRect().top + window.scrollY
//       window.scrollTo({
//         top: sectionPosition - offset,
//         behavior: 'smooth',
//       })
//     }
//   }

//   const menuItems = [
//     { href: '/', label: 'Home', isLink: true },
//     { href: '/Wellness', label: 'Wellness', isLink: true },
//     { href: '/membership', label: 'Membership', isLink: true },
//     { href: '/community-medicine', label: 'Community Medicine', isLink: true },
//     { href: '/give-back', label: 'Give Back', isLink: true },
//     { href: '/sign-in', label: 'Login', isLink: true },
//   ]

//   return (
//     <Navbar
//       expand='md'
//       fixed='top'
//       className='bg-white shadow-lg w-100'
//       style={{
//         backdropFilter: 'blur(10px)',
//         transition: 'all 0.3s ease-in-out',
//         maxWidth: '100vw',
//         overflowX: 'hidden',
//       }}
//     >
//       <Container fluid>
//         <Navbar.Brand
//           className='d-flex align-items-center flex-wrap'
//           style={{ maxWidth: '100%' }}
//         >
//           <img
//             src={AiLogo}
//             alt='Museum Logo'
//             className='me-2'
//             width={180}
//             height={60}
//             style={{ marginRight: '20px', marginLeft: '20px' }}
//           />
//         </Navbar.Brand>

//         <Navbar.Toggle aria-controls='basic-navbar-nav' />

//         <Navbar.Collapse id='basic-navbar-nav' className='justify-content-end'>
//           <Nav className='align-items-center'>
//             {menuItems.map(({ id, label, href, isLink }) =>
//               isLink ? (
//                 <Link
//                   key={label}
//                   to={href}
//                   className='nav-link'
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px',
//                     color: location.pathname === href ? '#000000' : '#1669C9', // active color
//                     fontWeight: '600',
//                     padding: '10px 20px',
//                     margin: '0 10px',
//                     transition: 'color 0.3s ease, transform 0.3s ease',
//                     cursor: 'pointer',
//                     textDecoration: 'none',
//                   }}
//                 >
//                   {label}
//                 </Link>
//               ) : (
//                 <span
//                   key={id}
//                   className='nav-link'
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '10px',
//                     color: '#1669C9',
//                     fontWeight: '500',
//                     padding: '10px 20px',
//                     margin: '0 10px',
//                     transition: 'color 0.3s ease, transform 0.3s ease',
//                     cursor: 'pointer',
//                   }}
//                   onClick={() => scrollToSection(id)}
//                 >
//                   {label}
//                 </span>
//               )
//             )}
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   )
// }

// export default Header

import React, { useState } from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap'
import Logo from '../Assets/Assests/final_logo_AI museum.png'
import '../Styles/Header.css'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import AiLogo from '../Assets/Assests/Logos/Tesla bird logo.png'
// import AiLogo from '../Assets/Assests/shared image- 1 (2).png'

const Header = () => {
  const location = useLocation()
  const [hoveredLink, setHoveredLink] = useState(null)

  const scrollToSection = (id) => {
    const section = document.getElementById(id)
    if (section) {
      const offset = 80
      const sectionPosition =
        section.getBoundingClientRect().top + window.scrollY
      window.scrollTo({
        top: sectionPosition - offset,
        behavior: 'smooth',
      })
    }
  }

  const menuItems = [
    { href: '/', label: 'Home', isLink: true },
    { href: '/Wellness', label: 'Wellness', isLink: true },
    { href: '/membership', label: 'Membership', isLink: true },
    { href: '/community-medicine', label: 'Community Medicine', isLink: true },
    { href: '/give-back', label: 'Give Back', isLink: true },
    { href: '/sign-in', label: 'Login', isLink: true },
  ]

  const getLinkStyle = (href) => {
    const isActive = location.pathname === href
    const isHovered = hoveredLink === href

    return {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color: isActive
        ? '#1669C9'
        : isHovered
        ? '#1669C9' // Hover color
        : '#000000', // Default
      fontWeight: isActive ? '700' : '600',
      padding: '10px 20px',
      margin: '0 10px',
      transition: 'color 0.3s ease, transform 0.3s ease',
      cursor: 'pointer',
      textDecoration: 'none',
    }
  }

  return (
    <Navbar
      expand='md'
      fixed='top'
      className='bg-white shadow-lg w-100'
      style={{
        backdropFilter: 'blur(10px)',
        transition: 'all 0.3s ease-in-out',
        maxWidth: '100vw',
        overflowX: 'hidden',
      }}
    >
      <Container fluid>
        <Navbar.Brand
          className='d-flex align-items-center flex-wrap'
          style={{ maxWidth: '100%' }}
        >
          <img
            src={AiLogo}
            alt='Museum Logo'
            width={80}
            height={80}
            style={{ marginRight: '20px', marginLeft: '20px' }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls='basic-navbar-nav' />

        <Navbar.Collapse id='basic-navbar-nav' className='justify-content-end'>
          <Nav className='align-items-center'>
            {menuItems.map(({ id, label, href, isLink }) =>
              isLink ? (
                <Link
                  key={label}
                  to={href}
                  className='nav-link'
                  style={getLinkStyle(href)}
                  onMouseEnter={() => setHoveredLink(href)}
                  onMouseLeave={() => setHoveredLink(null)}
                >
                  {label}
                </Link>
              ) : (
                <span
                  key={id}
                  className='nav-link'
                  style={getLinkStyle(id)}
                  onClick={() => scrollToSection(id)}
                  onMouseEnter={() => setHoveredLink(id)}
                  onMouseLeave={() => setHoveredLink(null)}
                >
                  {label}
                </span>
              )
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default Header
